import React from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { categories, menu } from '../../data/menu';
interface MenuListProps {
  quantities: Record<string, number>;
  onAdd: (id: string) => void;
  onRemove: (id: string) => void;
}
export function MenuList({
  quantities,
  onAdd,
  onRemove
}: MenuListProps) {
  return <div className="space-y-12" data-id="element-224" data-mp="vrp9o4vtv6u2">
      {categories.map(category => {
      const items = menu.filter(item => item.category === category.id);
      return <section key={category.id} aria-labelledby={`cat-${category.id}`} data-id="element-225" data-mp="14tom0jvwdmqo">
            <div className="flex flex-wrap items-baseline justify-between gap-2 border-b-[3px] border-noir pb-2" data-id="element-226" data-mp="14rkku9pdv1u3">
              <h2 id={`cat-${category.id}`} className="font-display text-2xl uppercase leading-none md:text-3xl" data-id="element-227" data-mp="1eji0ptrc6hz5">
                {category.label}
              </h2>
              <p className="text-xs uppercase tracking-[0.12em] text-noir/55" data-id="element-228" data-mp="1ohxpvr6szh60">{category.hint}</p>
            </div>

            <ul className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-229" data-mp="ec62zypasofe">
              {items.map(item => {
            const quantity = quantities[item.id] ?? 0;
            return <li key={item.id} className={`flex flex-col border-[3px] border-noir bg-white ${item.soldOut ? 'opacity-60' : ''}`} data-id="element-230" data-mp="nb9iytt64npo">
                    {item.image && <img src={item.image} alt={item.name} className="h-36 w-full border-b-[3px] border-noir object-cover" data-id="element-231" data-mp="11bkcy5pryif2" />}
                    <div className="flex flex-1 flex-col p-4" data-id="element-232" data-mp="1b0c3qaj3mwoe">
                      <div className="flex items-start justify-between gap-3" data-id="element-233" data-mp="1g0qcjusiyanh">
                        <div data-id="element-234" data-mp="1fync0gtqwz4i">
                          <h3 className="font-display text-lg uppercase leading-none" data-id="element-235" data-mp="1kz1l82732f44">{item.name}</h3>
                          <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-canard" data-id="element-236" data-mp="vamdrbkcahi0">
                            {item.origin}
                          </p>
                        </div>
                        <span className="shrink-0 border-[3px] border-noir bg-jaune px-2 py-0.5 font-display text-base leading-tight" data-id="element-237" data-mp="152a9honxikpa">
                          {item.price.toFixed(2).replace('.', ',')} €
                        </span>
                      </div>

                      <p className="mt-2 text-sm leading-relaxed text-noir/70" data-id="element-238" data-mp="1932lgpo6r3p9">{item.description}</p>

                      {item.tags && item.tags.length > 0 && <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-239" data-mp="1nzbgff11muvv">
                          {item.tags.map(tag => <li key={tag} className="border-2 border-noir px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide" data-id="element-240" data-mp="3prg6sm2w9k4h">
                              {tag}
                            </li>)}
                        </ul>}

                      <div className="mt-auto pt-4" data-id="element-241" data-mp="258m2l3wgcpkj">
                        {item.soldOut ? <span className="block border-[3px] border-noir bg-noir/5 py-2 text-center font-display text-sm uppercase text-noir/60" data-id="element-242" data-mp="1qk986bd0jes5">
                            Épuisé aujourd’hui
                          </span> : quantity === 0 ? <button type="button" onClick={() => onAdd(item.id)} className="flex w-full items-center justify-center gap-2 border-[3px] border-noir bg-jaune py-2 font-display text-sm uppercase transition-transform duration-150 ease-out hover:-translate-y-0.5" data-id="element-243" data-mp="1lm7nxn3up9f3">
                            <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-244" data-mp="36z0wod71g1w6" />
                            Ajouter
                          </button> : <div className="flex items-center justify-between border-[3px] border-noir bg-jaune" data-id="element-245" data-mp="11xoljg78udaj">
                            <button type="button" onClick={() => onRemove(item.id)} aria-label={`Retirer un ${item.name}`} className="px-4 py-2 transition-colors duration-150 ease-out hover:bg-jaune-dark" data-id="element-246" data-mp="xv1z5utcdkkq">
                              <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-247" data-mp="j4ugpf3c41k1" />
                            </button>
                            <span aria-live="polite" className="font-display text-lg leading-none" data-id="element-248" data-mp="a68vfc6ha8fk">
                              {quantity}
                            </span>
                            <button type="button" onClick={() => onAdd(item.id)} aria-label={`Ajouter un ${item.name}`} className="px-4 py-2 transition-colors duration-150 ease-out hover:bg-jaune-dark" data-id="element-249" data-mp="598q53hgd9pi">
                              <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-250" data-mp="2ltcdomv1316u" />
                            </button>
                          </div>}
                      </div>
                    </div>
                  </li>;
          })}
            </ul>
          </section>;
    })}
    </div>;
}